import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import CaseList from './pages/CaseList';
import CaseDetail from './pages/CaseDetail';
import NewCase from './pages/NewCase';
import Settings from './pages/Settings';
import EmailSettings from './pages/EmailSettings';
import Accounting from './pages/Accounting';
import Customers from './pages/Customers';
import Tasks from './pages/Tasks';
import Appointments from './pages/Appointments';
import Training from './pages/Training';
import DATIntegration from './pages/DATIntegration';
import Company from './pages/Company';
import UserManagement from './pages/UserManagement';
import Support from './pages/Support';
import ChatSupport from './pages/ChatSupport';
import Improvements from './pages/Improvements';
import Archive from './pages/Archive';
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';
import Barrierefreiheit from './pages/Barrierefreiheit';
import SuperAdmin from './pages/SuperAdmin';
import { Toaster} from 'sonner';
import { API_URL } from './config/api';
import './App.css';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem('token');
      if (token) {
        try {
          const response = await fetch(API_URL + '/api/auth/me', {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          });
          if (response.ok) {
            const userData = await response.json();
            setUser(userData);
          } else {
            localStorage.removeItem('token');
          }
        } catch (error) {
          console.error('Auth check failed:', error);
          localStorage.removeItem('token');
        }
      }
      setLoading(false);
    };
    checkAuth();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen" style={{backgroundColor: '#F5F7FA'}}>
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-gray-200" style={{borderTopColor: '#0A4D8C'}}></div>
      </div>
    );
  }

  return (
    <Router>
      <Toaster position="bottom-left" richColors />
      <Routes>
        <Route path="/login" element={user ? <Navigate to="/" /> : <Login setUser={setUser} />} />
        <Route path="/" element={user ? <Dashboard user={user} /> : <Navigate to="/login" />} />
        <Route path="/cases" element={user ? <CaseList user={user} /> : <Navigate to="/login" />} />
        <Route path="/cases/:id" element={user ? <CaseDetail user={user} /> : <Navigate to="/login" />} />
        <Route path="/new-case" element={user ? <NewCase user={user} /> : <Navigate to="/login" />} />
        <Route path="/accounting" element={user ? <Accounting user={user} /> : <Navigate to="/login" />} />
        <Route path="/customers" element={user ? <Customers user={user} /> : <Navigate to="/login" />} />
        <Route path="/tasks" element={user ? <Tasks user={user} /> : <Navigate to="/login" />} />
        <Route path="/appointments" element={user ? <Appointments user={user} /> : <Navigate to="/login" />} />
        <Route path="/training" element={user ? <Training user={user} /> : <Navigate to="/login" />} />
        <Route path="/settings" element={user ? <Settings user={user} setUser={setUser} /> : <Navigate to="/login" />} />
        <Route path="/email-settings" element={user ? <EmailSettings user={user} /> : <Navigate to="/login" />} />
        <Route path="/dat-integration" element={user ? <DATIntegration user={user} /> : <Navigate to="/login" />} />
        <Route path="/company" element={<Navigate to="/settings" replace />} />
        <Route path="/users" element={user ? <UserManagement user={user} /> : <Navigate to="/login" />} />
        <Route path="/support" element={user ? <Support user={user} /> : <Navigate to="/login" />} />
        <Route path="/chat-support" element={user ? <ChatSupport user={user} /> : <Navigate to="/login" />} />
        <Route path="/improvements" element={user ? <Improvements user={user} /> : <Navigate to="/login" />} />
        <Route path="/impressum" element={user ? <Impressum user={user} /> : <Navigate to="/login" />} />
        <Route path="/datenschutz" element={user ? <Datenschutz user={user} /> : <Navigate to="/login" />} />
        <Route path="/barrierefreiheit" element={user ? <Barrierefreiheit user={user} /> : <Navigate to="/login" />} />
        <Route path="/archive" element={user ? <Archive user={user} /> : <Navigate to="/login" />} />
        <Route path="/super-admin" element={user?.is_super_admin ? <SuperAdmin user={user} /> : <Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
